import React, { useState } from "react";
import Video from "interfaces/Video";

interface Tab {
  title: string;
  videos: Video[];
}

interface TutorialSidebarProps {
  tabs: Tab[];
  onTaskClick: (video: Video) => void;
  selectedVideoId: number | null;
}

const TutorialSidebar: React.FC<TutorialSidebarProps> = ({
  tabs,
  onTaskClick,
  selectedVideoId,
}) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <>
      <button
        className="fixed top-4 left-4 z-50 p-2 bg-app-blue text-white rounded-md mobile:block tablet:block laptop:hidden desktop:hidden largescreen:hidden xxl:hidden"
        onClick={toggleSidebar}
      >
        {isSidebarOpen ? (
          <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        )}
      </button>


      {/* Sidebar */}
      <div
        className={`
           fixed top-0 left-0 h-screen w-[280px] bg-white rounded-tr-3xl shadow-md flex flex-col z-40 transition-transform duration-300
          ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}
          laptop:translate-x-0 laptop:static laptop:w-[320px] desktop:translate-x-0 desktop:static desktop:w-[320px] largescreen:translate-x-0 largescreen:static largescreen:w-[320px] xxl:translate-x-0 xxl:static xxl:w-[320px]
          `}
      >
        {/* Tabs */}
        <div className="flex border-b border-app-blue text-sm">
          {tabs.map((tab, index) => (
            <div
              key={index}
              className={`flex-1 px-4 py-3 cursor-pointer text-center transition-all ${selectedTabIndex === index
                ? "text-app-blue font-semibold border-b-4 border-app-blue bg-white"
                : "text-gray-500 hover:text-app-blue"
                }`}
              onClick={() => setSelectedTabIndex(index)}
            >
              {tab.title}
            </div>
          ))}
        </div>

        {/* Video List */}
        <div className="overflow-y-auto p-4 flex-grow">
          {tabs[selectedTabIndex].videos.map((video) => (
            <div
              key={video.id}
              className={`flex gap-3 mb-4 p-3 rounded-lg cursor-pointer shadow-sm transition-all duration-150 ${selectedVideoId === video.id
                ? "bg-gradient-to-r from-app-blue to-app-purple text-white"
                : "bg-white border hover:bg-gray-100"
                }`}
              onClick={() => {
                onTaskClick(video);
                setIsSidebarOpen(false);
              }}
            >
              <img
                src={video.thumbnail}
                alt="Video Thumbnail"
                className="w-16 h-16 rounded-md object-cover"
              />
              <div className="flex flex-col justify-center">
                <h3 className="font-semibold text-sm">{video.title}</h3>
                <p className="text-xs opacity-70">
                  Duration: {video.duration} mins
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default TutorialSidebar;
